import React, { Component } from 'react';
import PropTypes from 'prop-types';

class VideoFrame extends Component {
    render() {
        return (
            <div
                width={this.props.width}
                height={this.props.height}
                //src={this.props.src}
                style={{
                    maxWidth: '100%',
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    margin: 'auto',
                    top: '50%',
                    transform: 'translateY(-50%)'
                }}
            >
                <video style={{ width: '100%' }} height={this.props.height} poster={this.props.thumb} controls>
                    <source src={this.props.src} type="video/mp4" />
                    Your browser does not support the video tag.
             </video>
            </div>
        );
    }
}

VideoFrame.propTypes = {
    src: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
};

export default VideoFrame;


// WEBPACK FOOTER //
// ./src/components/VideoFrame.js